import { baseUrl_SPB } from '../BaseUrl';

export default async function submitPartDeliveryRequest(payload) {
  try {
    const response = await fetch(`${baseUrl_SPB}/part-delivery/request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Unable to submit request');
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }

    return { success: true };
  } catch (error) {
    console.error('Error submitting part delivery request:', error);
    throw error;
  }
}
